import { render, staticRenderFns } from "./CustomStatusTransaction.vue?vue&type=template&id=67a20046&scoped=true"
import script from "./CustomStatusTransaction.vue?vue&type=script&lang=js"
export * from "./CustomStatusTransaction.vue?vue&type=script&lang=js"
import style0 from "./CustomStatusTransaction.vue?vue&type=style&index=0&id=67a20046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a20046",
  null
  
)

export default component.exports